const ALGOLIA_INSIGHTS_ENDPOINT = 'https://insights.de.algolia.io/1/events';

interface AlgoliaTrackingEventParamsBase {
  index: string;
}

interface ClickedObjectIDsAfterSearchEventParams extends AlgoliaTrackingEventParamsBase {
  queryID: string;
  objectIDs: string[];
  positions: number[];
}

interface ClickedObjectIDsEventParams extends AlgoliaTrackingEventParamsBase {
  objectIDs: string[];
}

interface ConvertedFiltersEventParams extends AlgoliaTrackingEventParamsBase {
  filters: string[];
}

type AlgoliaTrackingEventType = 'click' | 'conversion' | 'view';

function createEventDispatcher<T>(headers: Record<string, string>, userToken: string) {
  return (eventName: string, eventType: AlgoliaTrackingEventType) => {
    return (params: T) => {
      const body = JSON.stringify({ events: [{ eventName, eventType, userToken, ...params }] });
      fetch(ALGOLIA_INSIGHTS_ENDPOINT, {
        method: 'POST',
        headers,
        body,
      }).catch((error) => console.log(error));
    };
  };
}

type AlgoliaTrackingAgentParams = {
  appId: string;
  apiKey: string;
  userToken: string;
};

export interface AlgoliaTrackingAgent {
  clickedObjectIDsAfterSearch: (params: ClickedObjectIDsAfterSearchEventParams) => void;
  clickedObjectIDs: (params: ClickedObjectIDsEventParams) => void;
  convertedFilters: (params: ConvertedFiltersEventParams) => void;
}

export function createAlgoliaTrackingAgent(params: AlgoliaTrackingAgentParams): AlgoliaTrackingAgent {
  const { apiKey, appId, userToken } = params;
  const headers = {
    'x-algolia-api-key': apiKey,
    'x-algolia-application-id': appId,
    'Content-Type': 'application/json',
  };

  const eventDispatcher = createEventDispatcher(headers, userToken);

  return {
    clickedObjectIDs: eventDispatcher('clickedObjectIDs', 'click'),
    convertedFilters: eventDispatcher('convertedFilters', 'conversion'),
    clickedObjectIDsAfterSearch: eventDispatcher('clickedObjectIDsAfterSearch', 'click'),
  };
}
